import { PapiDeviation } from '@wix/da-papi-types';
import { type CreateAdoptableFormValues, FormField } from '../types';
import { getSourceUrlInputName, getSourceFilesInputName } from '../helpers';

export const adoptableSubmitAdapter = (
  deviation: PapiDeviation,
  {
    [FormField.SellAsFixed]: sell_as_fixed,
    [FormField.PurchasePrice]: purchase_price,
    [FormField.SellAsOffer]: sell_as_offer,
    [FormField.Offer]: offer,
    [FormField.Duration]: duration,
    [FormField.OfferDelayedStart]: offer_delayed_start,
    [FormField.AllowResale]: allow_resale,
    [FormField.EarlyAccess]: early_access,
    [FormField.AcceptTerms]: accept_terms,
    [FormField.Category]: necoid,
    ...remainingData
  }: CreateAdoptableFormValues
) => {
  const sourceFiles = remainingData[getSourceFilesInputName(deviation)] || [];
  return {
    deviationId: deviation.deviationId,
    necoid: necoid !== undefined ? Number(necoid) : undefined,
    purchase_price: sell_as_fixed ? purchase_price : undefined,
    duration: sell_as_offer ? duration : undefined,
    offer: sell_as_offer ? offer : undefined,
    offer_delayed_start,
    allow_resale,
    early_access,
    source_url: remainingData[getSourceUrlInputName(deviation)],
    include_original:
      sourceFiles.filter(file => file.deviationId === 0).length > 0,
    accept_terms,
  };
};

export const adoptableRelistAdapter = (
  deviation: PapiDeviation,
  {
    [FormField.SellAsFixed]: sell_as_fixed,
    [FormField.PurchasePrice]: purchase_price,
    [FormField.SellAsOffer]: sell_as_offer,
    [FormField.Offer]: offer,
    [FormField.Duration]: duration,
    [FormField.OfferDelayedStart]: offer_delayed_start,
    [FormField.AcceptTerms]: accept_terms,
  }: CreateAdoptableFormValues
) => ({
  deviationId: deviation.deviationId,
  purchase_price: sell_as_fixed ? purchase_price : undefined,
  duration: sell_as_offer ? duration : undefined,
  offer: sell_as_offer ? offer : undefined,
  offer_delayed_start,
  accept_terms,
});
